/* 
Jump To Edblog element behavior
*/
const jumper = document.querySelector(".js_jump-to-edblog");

if (jumper !== null) {
	jumper.addEventListener("click", (e) => {});

	//scroll tracker
	let tpm_jte_lastKnownScrollPosition = 0;
	let tpm_jte_ticking = false;

	function updateJumper(scrollPos) {
		// Do something with the scroll position

		const edblogTop =
			document.querySelector("#edblog").getBoundingClientRect().top +
			window.pageYOffset -
			window.innerHeight;

		//have we scrolled to the edblog yet?
		if (scrollPos > edblogTop) {
			if (!jumper.classList.contains("--to-top")) {
				jumper.classList.add("--to-top");
			}
		}
		//else we have not scrolled to the edblog
		else if (jumper.classList.contains("--to-top")) {
			jumper.classList.remove("--to-top");
		}
	}

	document.addEventListener("scroll", function (e) {
		tpm_jte_lastKnownScrollPosition = window.scrollY;

		if (!tpm_jte_ticking) {
			window.requestAnimationFrame(function () {
				updateJumper(tpm_jte_lastKnownScrollPosition);
				tpm_jte_ticking = false;
			});

			tpm_jte_ticking = true;
		}
	});
}

/*
tablet and narrow desktop stuff : /

todo; ideally there's a better way to handle this, maybe by registering new block styles
for the core/columns block? Need a solution that is easy to handle in the editor too

another idea is to create a "feature well/feature package" block that handles this stuff in it's styles
*/
window.tpm_resized = false;
function fpTabletStyleHack() {
	//magic number, 900px is about when the 2-columns of "feature well" content start to look bad
	const max = 1000;
	const mid = 781;
	const min = 599; //below this, we go single column
	const width = window.innerWidth;
	const isFpMobile = width <= min;
	const isFpTablet = width > min && width < mid;
	const isFpNarrowDesktop = width >= mid && width < max;
	const isFpFullDesktop = width >= max;

	function checkFor50PercentCol(style) {
		if (!style) return false;
		const re = /flex-basis:\s*50%/;
		return re.test(style);
	}

	//all 50% cols are 50% all the time.
	//these get ignored in the if-block below
	document.querySelectorAll(".wp-block-column").forEach((col) => {
		var style = col.getAttribute("style");
		if (checkFor50PercentCol(style)) {
			col.setAttribute("style", "flex-basis: 50% !important");
		}
	});

	if (isFpTablet || isFpNarrowDesktop) {
		if (window.tpm_resized === false) {
			window.tpm_resized = true;

			//get every column, if it has a style attr set it to that but !important;
			//this overrides wp core's column style for tablet widths, which are undesireable for us
			//have to do it like this instead of via CSS b/c of annoying !important's in the
			//core stylesheet that can't be overridden
			document.querySelectorAll(".wp-block-column").forEach((col) => {
				var style = col.getAttribute("style");
				if (checkFor50PercentCol(style)) return;

				col.setAttribute("style", style + "!important");
			});
		}
	} else if (isFpMobile || isFpFullDesktop) {
		//undo all the above
		if (window.tpm_resized === true) {
			//only do this once unless flag is flipped, oppsite of above
			window.tpm_resized = false;

			document.querySelectorAll(".wp-block-column").forEach((col) => {
				var style = col.getAttribute("style");
				if (!checkFor50PercentCol(style)) {
					col.setAttribute("style", style.replace("!important", ""));
				}
			});
		}
	}

	// blocks with .is-grid and exactly 2 articles get a special class
	// so they can be styled to be 50/50 on tablet/mobile
	const blocks = document.querySelectorAll(".wpnbha.is-grid");
	blocks.forEach((block) => {
		const articles = block.querySelectorAll("article");
		if (articles && articles.length === 2) {
			block.classList.add("tpm-two-up");
		}
	});

	// columns with more than 2 cols get a special class on each col
	// so they can be styled differently than their desktop settings
	// on tablet/mobile
	// this selector makes sure we only capture nested columns, we dont
	// want to do this for top level columns (edblog bar & its sibling)
	//excluding the special .is-style-live-blog-columns
	document
		.querySelectorAll(
			".wp-block-columns .wp-block-columns:not(.is-style-live-blog-columns)"
		)
		.forEach((columnsEl) => {
			if (columnsEl.children.length > 2) {
				columnsEl.querySelectorAll(".wp-block-column").forEach((col) => {
					col.classList.add("tpm-column-item");
				});
			}
		});

	//at mobile widths we have to dis- and re-assemble the feature live blog pattern
	//unless its a live-blog-columns-video group
	const el = document.querySelector(
		".wp-block-columns.is-style-live-blog-columns:not(.is-style-live-blog-columns-video) .is-style-timeline-style-bottom.wpnbha.ts-1.has-text-align-left"
	);
	if (el) {
		if (isFpMobile) {
			el.remove();
			el.setAttribute("style", "grid-column-start: 1;grid-column-end: 3;");
			document
				.querySelector(".wp-block-columns.is-style-live-blog-columns")
				.appendChild(el);
		} else {
			el.remove();
			el.setAttribute("style", "");
			document
				.querySelector(
					".wp-block-columns.is-style-live-blog-columns > .wp-block-column:first-child"
				)
				.appendChild(el);
		}
	}
}

//only do this for fp
if (document.body.classList.contains("newspack-front-page")) {
	fpTabletStyleHack();
	window.onresize = fpTabletStyleHack;
}

/* 
controls for newspack block tpm components with the horizontal/livewire style
*/
const hzCtrls = document.querySelectorAll(".js_fp-horizontal-control");

hzCtrls.forEach((ctrl) => {
	const dir = ctrl.dataset.direction;
	const grandparent = ctrl.parentElement.parentElement;
	const track = grandparent.querySelector(".js_scroll-track");
	window.track = track;

	let scrollDistance = track.offsetWidth / 3;
	//podcast-carousel gets styled via css, it has different concerns
	if (track.classList.contains("livewire") || track.classList.contains("--podcasts")) {
		if (scrollDistance < 250) scrollDistance = 250;

		track.querySelectorAll("article").forEach((el) => {
			el.style.width = scrollDistance + "px";
		});
	}


	if (track.classList.contains("podcast-carousel")) {
		const firstArticle = track.querySelector("article");
		if (firstArticle) {
			scrollDistance = firstArticle.offsetWidth;
		} else {
			scrollDistance = 300;
		}
	}

	if (track.classList.contains("newsletter-carousel")) {
		const firstArticle = track.querySelector("article");
		if (firstArticle) {
			scrollDistance = firstArticle.offsetWidth;
		} else {
			scrollDistance = 280;
		}
	}


	track.addEventListener("scroll", () => {
		/*
    .scrollBy (or .scroll, .scrollTo, for that matter) dont accept callbacks
    so theres no way to know when the document is done scrolling
    I need these measurements to happen after scrolling completes

    this fudges it well enough
    */
		setTimeout(() => {
			if (track.scrollLeft + track.offsetWidth >= track.scrollWidth) {
				//hide fwd
				grandparent
					.querySelector(".js_fp-horizontal-control.forward")
					.classList.add("disabled");
			} else {
				grandparent
					.querySelector(".js_fp-horizontal-control.forward")
					.classList.remove("disabled");
			}

			if (track.scrollLeft === 0) {
				//hide back
				grandparent
					.querySelector(".js_fp-horizontal-control.back")
					.classList.add("disabled");
			} else {
				grandparent
					.querySelector(".js_fp-horizontal-control.back")
					.classList.remove("disabled");
			}
		}, 500);
	});

	ctrl.addEventListener("click", (e) => {
		if (dir === "forward") {
			track.scrollBy({
				top: 0,
				left: scrollDistance, //width of item + flex gap
				behavior: "smooth",
			});
		} else if (dir === "back") {
			track.scrollBy({
				top: 0,
				left: -1 * scrollDistance,
				behavior: "smooth",
			});
		}
	});
});

/*
	handlers to reveal embedded youtube players for podcasts on fp & single post pages
	(podcast carousels & timeline-top live blog blocks alike)
*/
function pauseOtherYouTubeEmbeds(exceptIframe) {
	document.querySelectorAll(".js_podcast-youtube-embed iframe").forEach((iframe) => {
		if (iframe === exceptIframe) return;
		const src = iframe.getAttribute("src");
		if (!src) return;
		try {
			const url = new URL(src, window.location.origin);
			url.searchParams.set("autoplay", "0");
			iframe.setAttribute("src", url.toString());
		} catch (e) {
			/* ignore invalid URLs */
		}
	});
}

document.querySelectorAll(".js_podcast-youtube-reveal").forEach((ytReveal) => {
	ytReveal.addEventListener("click", () => {
		ytReveal.classList.add("--clicked");
		const ytContainer = ytReveal.nextElementSibling;
		if (!ytContainer || !ytContainer.classList.contains("js_podcast-youtube-embed")) return;
		ytContainer.classList.add("--show");

		pauseOtherYouTubeEmbeds(null);

		const iframe = ytContainer.querySelector("iframe");
		if (iframe) {
			const src = iframe.getAttribute("src");
			if (src) {
				try {
					const url = new URL(src, window.location.origin);
					url.searchParams.set("autoplay", "1");
					url.searchParams.set("mute", "0");
					iframe.setAttribute("src", url.toString());
				} catch (e) {
					/* ignore invalid URLs */
				}
			}
		}
	});
});


//for is-style-live-blog-columns-video pattern append the "2026 midterms" kicker element
//only care about the first instance on the page
const liveBlogVideoPattern = document.querySelector(".is-style-live-blog-columns-video");
if (liveBlogVideoPattern) {
	const kicker = document.createElement("div");
	kicker.classList.add("is-style-live-blog-columns-video-tag");


	const date = document.createElement("span");
	const dateOne = document.createElement("span");
	dateOne.textContent = "20"
	dateOne.style.color = "#0000FF";

	const dateTwo = document.createElement("span");
	dateTwo.textContent = "26"
	dateTwo.style.color = "#F42929";

	const midterms = document.createElement("span");
	midterms.textContent = " MIDTERMS";

	date.appendChild(dateOne);
	date.appendChild(dateTwo);
	kicker.appendChild(date);
	kicker.appendChild(midterms);

	document.querySelector('.front-page').prepend(kicker);
}	
